import { render, staticRenderFns } from "./GroupBannerCreateEditForm.vue?vue&type=template&id=14a3d11a&"
import script from "./GroupBannerCreateEditForm.vue?vue&type=script&lang=js&"
export * from "./GroupBannerCreateEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports